import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function LatestUpdates() {
  const latest = [...comics]
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, 8);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            最新更新
          </h2>
          <Link
            to="/category"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors no-underline flex items-center gap-1 whitespace-nowrap"
          >
            更多更新
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {latest.map((comic) => (
            <div key={comic.id} className="flex justify-center">
              <ComicCard comic={comic} size="medium" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}